export default __webpack_public_path__ + "static/media/020205202189104.e2c4d87d.png";